import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useRootStore } from '../../../stores/BridgeProvider';
import NewDealFromTemplate from './NewDealFromTemplate';
import { FlexDiv } from '../../styles/styles';
import { MenuList, filterOptions } from '../../util/ReactSelectOverrides';
import { CustomSelect } from '../../util/CustomCreatableSelect';
import Spinner from '../../util/Spinner';

const SelectTemplate = () => {
  const { state } = useLocation();
  const { authStore } = useRootStore();
  const [isLoading, setLoading] = useState(false);
  const [dealTemplates, setDealTemplates] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  useEffect(() => {
    const initialize = async () => {
      try {
        const { data } = await authStore.request.get(
          `${process.env.REACT_APP_API}/api/deal-templates`,
        );
        setDealTemplates(data);
        const { templateId } = state || {};
        if (templateId) {
          const template = data.find(
            e => parseInt(e.DealTemplateId, 10) === parseInt(templateId, 10),
          );
          if (template) setSelectedTemplate(template);
        }
      } catch (e) {
        console.error(e);
      }
      setLoading(false);
    };
    initialize();
  }, []);

  if (isLoading) return <Spinner />;
  return (
    <FlexDiv style={{ justifyContent: 'flex-start' }}>
      <div
        style={{
          width: '100%',
          zIndex: 1001,
          marginTop: '10px',
          maxWidth: '600px',
        }}
      >
        <CustomSelect
          isSearchable
          isClearable
          placeholder="Select Deal Template"
          components={{ MenuList }}
          options={dealTemplates}
          getOptionLabel={option => option.Name}
          getOptionValue={option => option}
          value={selectedTemplate}
          filterOption={filterOptions}
          onChange={val => setSelectedTemplate(val)}
        />
      </div>
      {selectedTemplate && (
        <NewDealFromTemplate templateId={selectedTemplate.DealTemplateId} />
      )}
    </FlexDiv>
  );
};

export default SelectTemplate;
